export const statuses = {
  open: 'Aberto',
  canceled: 'Cancelado',
  finished: 'Finalizado',
};

export function getName(value) {
  return statuses[value];
}
